import { render, staticRenderFns } from "./bigView.vue?vue&type=template&id=fe8c734c&scoped=true"
import script from "./bigView.vue?vue&type=script&lang=js"
export * from "./bigView.vue?vue&type=script&lang=js"
import style0 from "./bigView.vue?vue&type=style&index=0&id=fe8c734c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8c734c",
  null
  
)

export default component.exports